var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(!_vm.isHidden || _vm.localShow)?_c('div',{staticClass:"tw-flex tw-space-x-2 tw-justify-center",attrs:{"role":"alert"}},[_c('div',{class:[
        `tw-mb-4
      tw-bg-white
      tw-mx-auto
      tw-w-96
      tw-max-w-full
      tw-text-sm
      tw-pointer-events-auto
      tw-bg-clip-padding tw-rounded-lg
      tw-block
      tw-shadow`,
        _vm.color,
      ],attrs:{"id":"static-example","role":"alert","aria-live":"assertive","aria-atomic":"true","data-mdb-autohide":"false"}},[_c('div',{class:[
          `tw-flex
        tw-justify-between
        tw-items-center tw-py-2 tw-px-3
        tw-bg-clip-padding
        tw-border-b
        tw-border-gray-200
        tw-rounded-t-lg`,
          _vm.color,
        ]},[(_vm.resolvedVariant)?_c('div',{class:[
            `tw-inline-flex tw-flex-shrink-0
        tw-justify-center tw-items-center
        tw-w-6 tw-h-6
        tw-rounded-lg
        tw-mr-2`,
            _vm.iconColor,
          ]},[(_vm.resolvedVariant === 'danger')?_c('AlertCircleIcon',{attrs:{"size":_vm.iconSize}}):(_vm.resolvedVariant === 'warning')?_c('AlertTriangleIcon',{attrs:{"size":_vm.iconSize}}):(_vm.resolvedVariant === 'success')?_c('CheckIcon',{attrs:{"size":_vm.iconSize}}):(_vm.resolvedVariant === 'info')?_c('AlertTriangleIcon',{attrs:{"size":_vm.iconSize}}):_vm._e()],1):_vm._e(),_c('p',{staticClass:"tw-font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tw-flex tw-items-center tw-ml-auto"},[_c('button',{staticClass:"tw-ml-auto tw-rounded-lg tw-inline-flex tw-focus:ring-gray-300 tw-focus:ring-2 tw-text-gray-400 tw-hover:text-gray-900 tw-hover:bg-gray-100",attrs:{"aria-label":"Close","type":"button"},on:{"click":_vm.onClose}},[_c('span',{staticClass:"sr-only"},[_vm._v(" Close ")]),_c('XIcon',{staticClass:"tw-text-gray-800",attrs:{"size":_vm.iconSize}})],1)])]),_c('div',{class:[
          `tw-p-3
      tw-rounded-b-lg
      tw-break-words`,
          _vm.bodyColor,
        ]},[(_vm.isStatic)?_c('div',[(typeof _vm.content === 'string')?_c('div',[_vm._v(_vm._s(_vm.content))]):_c('div',[_c('ToastContent',{attrs:{"content":_vm.content}})],1),_c('content')]):_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }